<template>
  <component
      :is="'tablefield-' + usedConfig.decorator"
      :class="[usedConfig.decorator]"
      :config="usedConfig"
      :data="usedData"
      :product="product"
      name="fallback"
  ></component>
</template>

<script>


export default {
  name: 'tablefield-fallback',
  props: ['config', 'product', 'data'],
  components: {
    tablefieldPercent : () => import('./FieldPercent.vue'),
    tablefieldText : () => import('./FieldText.vue'),
    tablefieldCurrency : () => import('./FieldCurrency.vue'),
    tablefieldBoolean : () => import('./FieldBoolean.vue'),
    tablefieldDecimal : () => import('./FieldDecimal.vue'),
    tablefieldDate : () => import('./FieldDate.vue'),
  },
  data() {
    return {
      usedData: null,
      usedConfig: null,
    }
  },
  created() {
    if (this.data[0] !== null) {
      this.usedData = this.data[0]
      this.usedConfig = this.config.decoratorOptions.lines[0]
    } else {
      this.usedData = this.data[1]
      this.usedConfig = this.config.decoratorOptions.lines[1]
    }
  },
  methods: {},
}
</script>



// WEBPACK FOOTER //
// FieldFallback.vue?39478227